/**
 * NWT_Core_Services
 * <h1>NWT_Core_Services</h1>
 *
 * OpenAPI spec version: 
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type JsonHierarchyElementType = 'NODE' | 'CMTS' | 'Facility' | 'Group' | 'DAC' | 'NetworkController' | 'StreamPath';

export const JsonHierarchyElementType = {
    NODE: 'NODE' as JsonHierarchyElementType,
    CMTS: 'CMTS' as JsonHierarchyElementType,
    Facility: 'Facility' as JsonHierarchyElementType,
    Group: 'Group' as JsonHierarchyElementType,
    DAC: 'DAC' as JsonHierarchyElementType,
    NetworkController: 'NetworkController' as JsonHierarchyElementType,
    StreamPath: 'StreamPath' as JsonHierarchyElementType
}
